import { useSelector } from 'react-redux'

import { Chart } from 'primereact/chart'
import NumberFormat from 'react-number-format'

export const ReportByAreas = ({ data }) => {

    const { access } = useSelector(state => state.auth)
    // const { simbolo, separacion_miles, separacion_decimales } = useSelector(state => state.general.detail)

    const {
        // local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)

    return (
        <div className="mt-4 bg-white p-3 rounded-2xl">
            <h5 className="text-[15px]">Por unidad de negocio</h5>

            <div className='table-responsive'>
                <table className="table p-table-global mt-2">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th className="text-start">Área</th>
                            <th>Cant. Ventas</th>
                            <th>Total Ventas Netas</th>
                            {access.a21 &&
                                <>
                                    <th>Rentabilidad real</th>
                                    <th>Margen Prom.</th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map(it => {
                            if (it.cant_ventas > 0) {
                                return (
                                    <tr className='p-tr-body-global' key={it.id}>
                                        <td className="text-start">{it.area}</td>
                                        <td className="text-center">{it.cant_ventas}</td>
                                        <td className="text-end">
                                            <NumberFormat
                                                value={it?.total_ventas}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale={2}
                                            />
                                        </td>

                                        {access.a21 &&
                                            <>
                                                <td className="text-end">
                                                    <NumberFormat
                                                        value={it?.total_rentabilidad_real}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale={2}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <NumberFormat
                                                        // value={it?.margen_promedio_real}
                                                        value={(parseFloat(it?.total_rentabilidad_real) / parseFloat(it?.total_ventas)) * 100}
                                                        displayType={'text'}
                                                        thousandSeparator={','}
                                                        decimalSeparator='.'
                                                        decimalScale={2}
                                                        suffix="%"
                                                    />
                                                </td>
                                            </>
                                        }

                                    </tr>
                                )
                            }

                            return ''

                        })}
                    </tbody>
                </table>
            </div>

            <div className="col d-flex justify-content-center mt-4">
                <BarChart
                    data={data}
                    access={access}
                />
            </div>
        </div>

    )
}

const BarChart = ({ data, access }) => {

    let names = []
    let aprobados = []
    let ventas = []
    let rent = []

    for (let x = 0; x < data.length; x++) {
        if (data[x].total_ventas > 0) {
            names = [...names, (data[x].area).toUpperCase()]
            aprobados = [...aprobados, data[x].total_rentabilidad]
            ventas = [...ventas, data[x].total_ventas]
            rent = [...rent, data[x].total_rentabilidad]
        }
    }

    let dataSet = []
    if (access.a21) {
        dataSet = [
            {
                type: 'bar',
                label: 'Ventas',
                backgroundColor: '#b6cfff',
                data: ventas,
                borderColor: 'white',
                borderWidth: 2
            },
            {
                type: 'bar',
                label: 'Rentabilidad Estimada',
                backgroundColor: '#5CBF66',
                data: rent,
                borderColor: 'white',
                borderWidth: 2
            }
        ]
    } else {
        dataSet = [
            {
                type: 'bar',
                label: 'Ventas',
                backgroundColor: '#b6cfff',
                data: ventas,
                borderColor: 'white',
                borderWidth: 2
            }
        ]
    }

    const chartData = {
        labels: names,
        datasets: dataSet
    };

    const chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    }

    return (
        <Chart type="line" data={chartData} options={chartOptions} style={{ position: 'relative', width: '100%' }} />
    )

}
